import { useState, useEffect } from 'react';
import axios from 'axios';
import Accordion from 'react-bootstrap/Accordion';
import Spinner from '../spinner/Spinner';

export default function Faq() {  
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    loadFaqs();
  },[]);

  const loadFaqs = async () => {
    try{
      setLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_PATH}faqs/public`);
      setLoading(false);
      const { error, data } = res.data;

      if(!error && Array.isArray(data) && data.length > 0){
        setFaqs(data);
      }
    }catch(err){
      setLoading(false);
      console.error(err);
    }
  }

  return (
      <div className="container-xxl py-5">          
        <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: "600px"}}>
            <h1 className="mb-3">Frequently Asked Questions</h1>                   
        </div>            
          {
              loading ?                     
              <Spinner message='Loading Services' />                    
          :
            <section id="faq" className="container">        
                  <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: "600px"}}>                            
                  </div>
                  <Accordion> 
                    {
                      faqs.map((item)=>{
                        return <Accordion.Item eventKey={item.id} key={item.id}>
                          <Accordion.Header>{item.question}</Accordion.Header>
                          <Accordion.Body>                      
                            <div
                              className="text-gray-700 text-lg leading-7 prose max-w-none"
                              dangerouslySetInnerHTML={{ __html: item.answer }}
                            />
                          </Accordion.Body>
                        </Accordion.Item>
                      }) 
                    }
              </Accordion>
            </section>
          }            
      </div>
  );
}